import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Admissions from "./pages/Admissions";
import Contact from "./pages/Contact";
import MediaGallery from "./pages/MediaGallery";
import UploadMedia from "./pages/UploadMedia";
import AdminEvents from "./pages/AdminEvents";
import UserEvents from "./pages/UserEvents";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/admissions" element={<Admissions />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/media" element={<MediaGallery />} />
        <Route path="/upload" element={<UploadMedia />} />
        <Route path="/admin-events" element={<AdminEvents />} />
        <Route path="/user-events" element={<UserEvents />} />
      </Routes>
    </Router>
  );
};

export default App;
